import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import {
  Button,
  ButtonGroup
} from '@material-ui/core';

import DashboardCards from 'components/Dashboard/DashboardCards';
import DashboardCharts from 'components/Dashboard/DashboardCharts';
//import DashboardTables from 'components/Dashboard/DashboardTables';
import ScanProductModal from 'components/Dashboard/ScanProductModal';

import { owner, standard } from 'constants/userAccountTypes';

const mapStateToProps = (state) => ({
  activeUserType: state.activeUserType,
  customers: state.customers,
  products: state.products,
  salesOrders: state.salesOrders,
  expenses: state.expenses
});

const Dashboard = (props) => {
  
  const navigate = useNavigate();

  const [openScanModal, setOpenScanModal] = useState(false);

  const navigateToComponent = (destination) => {
    navigate(`/app/${destination}`, { replace: true });
  };

  const handleScanModalClose = () => {
    setOpenScanModal(false)
  };  

  return (
    <>
      <Helmet>
        <title>Dashboard | Duot Khayat</title>
      </Helmet>
      <ButtonGroup color="primary" aria-label="text primary button group">
        { !(props.activeUserType === owner) ?
        <Button
          onClick={() => navigateToComponent("salesOrders")}
        >
          Sales Orders
        </Button> : null }
        { !(props.activeUserType === owner) ?
        <Button
          onClick={() => navigateToComponent("customers")}
        >
          Customers
        </Button> : null }
        <Button
          onClick={() => navigateToComponent("products")}
        >
          Products
        </Button>
        { !(props.activeUserType === standard) ?
        <Button
          onClick={() => navigateToComponent("processes")}
        >
          Processes
        </Button> : null }
        { props.activeUserType === owner ?
        <Button
          onClick={() => navigateToComponent("employees")}
        >
          Employees
        </Button> : null }
        { !(props.activeUserType === owner) ?
        <Button
          onClick={() => navigateToComponent("expenses")}
        >
          Expenses
        </Button> : null }
        <Button
          color="primary"
          variant="contained"
          onClick={() => setOpenScanModal(true)}
        >
          Scan Product
        </Button>
      </ButtonGroup>      
      <DashboardCards
        salesOrders={props.salesOrders}
        expenses={props.expenses}
      />
      <DashboardCharts
        salesOrders={props.salesOrders}
        expenses={props.expenses}
      />
      {/* props.activeUserType === standard ?
      <DashboardTables
        salesOrders={props.salesOrders.filter(SO => SO.payments.length > 0)}
        customers={props.customers}
      /> : null */}
      { openScanModal ?
      <ScanProductModal
        open={openScanModal}
        products={props.products}
        closeModal={handleScanModalClose}
      /> : null }
    </>
  )
};

export default connect (mapStateToProps) (Dashboard);